// AUTO-GENERATED — do not edit. Run `pnpm build-content-index`.
const index = {
  "site": {
    "brand": {
      "name": "PowerQuant",
      "tagline": "Systematic Trading · EST 2018",
      "mark": "P",
      "legalName": "POWERQUANT ASSETS LLC",
      "offices": [
        "GHANA",
        "HONG KONG",
        "SINGAPORE"
      ],
      "email": "info@powerquanthq.com"
    },
    "compliance": {
      "chips": [],
      "disclaimer": "This material is for informational purposes only and does not constitute investment advice, an offer to sell, or a solicitation of an offer to buy any security. Past performance is not indicative of future results."
    },
    "ticker": [
      {
        "sym": "ES",
        "px": "5,210.50",
        "chg": "+0.52%",
        "dir": "up"
      },
      {
        "sym": "NQ",
        "px": "18,420.25",
        "chg": "+0.84%",
        "dir": "up"
      },
      {
        "sym": "BTC",
        "px": "64,200.00",
        "chg": "-1.20%",
        "dir": "down"
      },
      {
        "sym": "ETH",
        "px": "3,420.00",
        "chg": "+0.10%",
        "dir": "flat"
      },
      {
        "sym": "GC",
        "px": "2,380.50",
        "chg": "+0.21%",
        "dir": "up"
      },
      {
        "sym": "CL",
        "px": "78.42",
        "chg": "-0.55%",
        "dir": "down"
      },
      {
        "sym": "EUR",
        "px": "1.0890",
        "chg": "+0.03%",
        "dir": "flat"
      },
      {
        "sym": "JPY",
        "px": "156.82",
        "chg": "+0.18%",
        "dir": "up"
      }
    ],
    "nav": [
      {
        "href": "/strategies",
        "label": "Strategies"
      },
      {
        "href": "/performance",
        "label": "Performance"
      },
      {
        "href": "/research",
        "label": "Research"
      },
      {
        "href": "/pricing",
        "label": "Pricing"
      },
      {
        "href": "/about",
        "label": "About"
      }
    ],
    "footer": {
      "columns": [
        {
          "heading": "Product",
          "links": [
            {
              "label": "Strategies",
              "href": "/strategies"
            },
            {
              "label": "Performance",
              "href": "/performance"
            },
            {
              "label": "Pricing",
              "href": "/pricing"
            }
          ]
        },
        {
          "heading": "Company",
          "links": [
            {
              "label": "About",
              "href": "/about"
            },
            {
              "label": "Research",
              "href": "/research"
            },
            {
              "label": "Docs",
              "href": "/docs"
            }
          ]
        }
      ]
    }
  },
  "strategies": [
    {
      "id": "altair",
      "code": "PQ-ALT-002",
      "name": "Altair",
      "tagline": "Crypto stat-arb across centralized venues",
      "description": "Statistical arbitrage on a basket of crypto majors across the top three centralized venues, with funding-rate aware sizing and a basis overlay.",
      "category": "Digital Assets",
      "style": "Stat Arb",
      "instruments": [
        "BTC",
        "ETH",
        "SOL"
      ],
      "minCapital": 50000,
      "sharpe": 1.88,
      "cagr": 34.6,
      "maxDD": -12.4,
      "winRate": 56.8,
      "avgHold": "6.2d",
      "trades": 1432,
      "inception": "2022-01",
      "monthly": "+2.41%",
      "ytd": "+22.10%",
      "lifetime": "+96.1%",
      "status": "live",
      "capacity": 48,
      "tier": "pro",
      "color": "cyan"
    },
    {
      "id": "atlas",
      "code": "PQ-ATL-010",
      "name": "Atlas",
      "tagline": "Crypto trend with regime gate",
      "description": "Trend-following on the top crypto majors with a Bayesian regime gate that throttles exposure during high-correlation drawdowns.",
      "category": "Digital Assets",
      "style": "Trend Following",
      "instruments": [
        "BTC",
        "ETH"
      ],
      "minCapital": 25000,
      "sharpe": 1.05,
      "cagr": 38.2,
      "maxDD": -22.4,
      "winRate": 44.8,
      "avgHold": "16.4d",
      "trades": 220,
      "inception": "2021-01",
      "monthly": "+3.10%",
      "ytd": "+24.80%",
      "lifetime": "+118.6%",
      "status": "live",
      "capacity": 70,
      "tier": "starter",
      "color": "amber"
    },
    {
      "id": "halo",
      "code": "PQ-HAL-011",
      "name": "Halo",
      "tagline": "HFT order-book imbalance",
      "description": "High-frequency execution model exploiting order-book imbalances on liquid US equity venues. Capacity is hard-capped by venue throughput.",
      "category": "HFT",
      "style": "Microstructure",
      "instruments": [
        "US Equities"
      ],
      "minCapital": 500000,
      "sharpe": 3.22,
      "cagr": 24.6,
      "maxDD": -3.4,
      "winRate": 68.2,
      "avgHold": "2.1s",
      "trades": 184220,
      "inception": "2022-05",
      "monthly": "+2.04%",
      "ytd": "+15.60%",
      "lifetime": "+62.4%",
      "status": "waitlist",
      "capacity": 96,
      "tier": "institutional",
      "color": "rose"
    },
    {
      "id": "kestrel",
      "code": "PQ-KES-005",
      "name": "Kestrel",
      "tagline": "FX carry with macro overlay",
      "description": "Carry across G10 currency pairs, sized by realized vol and overlaid with a regime filter that cuts exposure during macro tail events.",
      "category": "FX",
      "style": "Carry",
      "instruments": [
        "EURUSD",
        "USDJPY",
        "AUDUSD"
      ],
      "minCapital": 100000,
      "sharpe": 1.42,
      "cagr": 14.2,
      "maxDD": -8.4,
      "winRate": 58,
      "avgHold": "9.1d",
      "trades": 712,
      "inception": "2020-06",
      "monthly": "+1.10%",
      "ytd": "+8.40%",
      "lifetime": "+62.0%",
      "status": "live",
      "capacity": 55,
      "tier": "pro",
      "color": "rose"
    },
    {
      "id": "lyra",
      "code": "PQ-LYR-008",
      "name": "Lyra",
      "tagline": "Energy curve roll yield",
      "description": "Captures roll yield in WTI and Brent futures curves with a contango/backwardation classifier and seasonal-aware position sizing.",
      "category": "Commodities",
      "style": "Roll Yield",
      "instruments": [
        "CL",
        "BZ"
      ],
      "minCapital": 50000,
      "sharpe": 1.34,
      "cagr": 17.9,
      "maxDD": -13.2,
      "winRate": 51.8,
      "avgHold": "12.6d",
      "trades": 384,
      "inception": "2019-04",
      "monthly": "+1.42%",
      "ytd": "+10.10%",
      "lifetime": "+92.4%",
      "status": "live",
      "capacity": 33,
      "tier": "pro",
      "color": "amber"
    },
    {
      "id": "meridian",
      "code": "PQ-MER-001",
      "name": "Meridian",
      "tagline": "Mean reversion on liquid futures",
      "description": "Intraday mean reversion across S&P futures with a regime filter and dynamic sizing. Risk is sized off realized vol, with an overlay that scales down in fast-moving regimes.",
      "category": "Futures",
      "style": "Mean Reversion",
      "instruments": [
        "ES",
        "NQ"
      ],
      "minCapital": 25000,
      "sharpe": 2.41,
      "cagr": 28.4,
      "maxDD": -7.2,
      "winRate": 61.2,
      "avgHold": "47min",
      "trades": 2847,
      "inception": "2021-03",
      "monthly": "+3.12%",
      "ytd": "+18.42%",
      "lifetime": "+142.8%",
      "status": "live",
      "capacity": 72,
      "tier": "pro",
      "color": "amber",
      "detail": {
        "thesis": "Liquid index futures display short-horizon mean reversion outside of news-driven regimes. Meridian identifies and trades these reversion windows with a regime filter that flattens exposure during structural moves.",
        "mechanics": [
          {
            "heading": "Signal",
            "body": "A short-window z-score on residuals after a regression on the prior session's range. We trade when the residual exceeds a calibrated threshold."
          },
          {
            "heading": "Sizing",
            "body": "Position size is inversely proportional to a 30-minute realized vol estimate, capped at 1.5x the median bar's notional."
          },
          {
            "heading": "Risk",
            "body": "Hard stop at 1.4x the entry's expected adverse excursion. A regime classifier (driven by realized correlation between ES and breadth) flattens the book in trending regimes."
          }
        ],
        "sampleCodeBlock": "def signal(bar, ctx):\n    z = (bar.close - ctx.fitted) / ctx.sigma\n    if abs(z) < ctx.threshold:\n        return 0\n    return -np.sign(z) * size_for_vol(ctx.vol_30m)"
      }
    },
    {
      "id": "nova",
      "code": "PQ-NOV-009",
      "name": "Nova",
      "tagline": "Earnings drift",
      "description": "Post-earnings announcement drift across US large- and mid-caps, gated by surprise magnitude and analyst-revision velocity.",
      "category": "Equities",
      "style": "Event Driven",
      "instruments": [
        "US Equities"
      ],
      "minCapital": 50000,
      "sharpe": 1.62,
      "cagr": 21.4,
      "maxDD": -9.8,
      "winRate": 57.6,
      "avgHold": "5.1d",
      "trades": 1180,
      "inception": "2021-09",
      "monthly": "+1.78%",
      "ytd": "+13.40%",
      "lifetime": "+58.1%",
      "status": "live",
      "capacity": 47,
      "tier": "pro",
      "color": "lime"
    },
    {
      "id": "orion",
      "code": "PQ-ORI-006",
      "name": "Orion",
      "tagline": "Equity factor rotation",
      "description": "Rotates between value, momentum, quality, and low-vol equity factors based on a regime classifier trained on macro and credit data.",
      "category": "Equities",
      "style": "Factor Rotation",
      "instruments": [
        "SPY",
        "QQQ",
        "IWM"
      ],
      "minCapital": 100000,
      "sharpe": 1.18,
      "cagr": 12.6,
      "maxDD": -11,
      "winRate": 53.4,
      "avgHold": "21d",
      "trades": 248,
      "inception": "2019-10",
      "monthly": "+1.02%",
      "ytd": "+7.20%",
      "lifetime": "+71.4%",
      "status": "live",
      "capacity": 41,
      "tier": "pro",
      "color": "violet"
    },
    {
      "id": "polaris",
      "code": "PQ-POL-004",
      "name": "Polaris",
      "tagline": "Trend-following on global futures",
      "description": "Long-horizon trend-following across a diversified basket of futures: equities, rates, FX, and commodities. Slow-moving, robust, and uncorrelated with the rest of the book.",
      "category": "Futures",
      "style": "Trend Following",
      "instruments": [
        "ES",
        "ZN",
        "6E",
        "GC",
        "CL"
      ],
      "minCapital": 5000,
      "sharpe": 0.92,
      "cagr": 11.4,
      "maxDD": -14.8,
      "winRate": 41,
      "avgHold": "28d",
      "trades": 318,
      "inception": "2018-03",
      "monthly": "+0.86%",
      "ytd": "+6.12%",
      "lifetime": "+74.3%",
      "status": "live",
      "capacity": 35,
      "tier": "starter",
      "color": "lime"
    },
    {
      "id": "rigel",
      "code": "PQ-RIG-007",
      "name": "Rigel",
      "tagline": "Treasury futures basis",
      "description": "Cash-vs-futures basis trading on the long end of the US Treasury curve, with a slow-moving directional overlay tied to real-yield momentum.",
      "category": "Fixed Income",
      "style": "Basis",
      "instruments": [
        "ZN",
        "ZB"
      ],
      "minCapital": 250000,
      "sharpe": 1.71,
      "cagr": 9.8,
      "maxDD": -4.6,
      "winRate": 64.2,
      "avgHold": "3.4d",
      "trades": 921,
      "inception": "2020-02",
      "monthly": "+0.78%",
      "ytd": "+5.60%",
      "lifetime": "+48.2%",
      "status": "live",
      "capacity": 68,
      "tier": "institutional",
      "color": "cyan"
    },
    {
      "id": "vega",
      "code": "PQ-VEG-003",
      "name": "Vega",
      "tagline": "Short-vol with hard tail risk",
      "description": "Sells short-dated index volatility while running a continuously hedged tail-risk overlay. Risk capped by net vega and a hard variance budget — designed for institutional capacity.",
      "category": "Volatility",
      "style": "Vol Selling",
      "instruments": [
        "SPX",
        "NDX"
      ],
      "minCapital": 250000,
      "sharpe": 2.05,
      "cagr": 19.8,
      "maxDD": -9.6,
      "winRate": 71.4,
      "avgHold": "11.4d",
      "trades": 612,
      "inception": "2020-09",
      "monthly": "+1.84%",
      "ytd": "+12.30%",
      "lifetime": "+88.6%",
      "status": "live",
      "capacity": 60,
      "tier": "institutional",
      "color": "violet"
    },
    {
      "id": "vesper",
      "code": "PQ-VES-012",
      "name": "Vesper",
      "tagline": "Catalyst-driven event book",
      "description": "Discretionary-overlay event-driven book around announced corporate catalysts (M&A, spinoffs, buybacks). Systematic in sizing, judgmental in selection.",
      "category": "Event Driven",
      "style": "Catalyst",
      "instruments": [
        "US Equities"
      ],
      "minCapital": 500000,
      "sharpe": 1.91,
      "cagr": 16.8,
      "maxDD": -7.4,
      "winRate": 62,
      "avgHold": "31d",
      "trades": 88,
      "inception": "2021-11",
      "monthly": "+1.34%",
      "ytd": "+9.80%",
      "lifetime": "+44.6%",
      "status": "paused",
      "capacity": 22,
      "tier": "institutional",
      "color": "violet"
    }
  ],
  "articles": [
    {
      "id": "a01",
      "cat": "Research",
      "title": "The Half-Life of Alpha",
      "author": "D. Caldwell",
      "date": "2024-08-12",
      "read": 9,
      "tag": "Research",
      "hero": true,
      "lead": "Edges decay. We measured how fast across a decade of signals from our own book — and the half-lives are shorter than the consensus thinks.",
      "body": [
        {
          "kind": "paragraph",
          "text": "Every systematic shop has the same conversation eventually: a signal that worked for years suddenly stops paying. The question is never whether it decays — it always does — but how fast. We pulled the live PnL series of every signal we have run since 2014 and fit an exponential decay to each."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "The numbers"
        },
        {
          "kind": "paragraph",
          "text": "The median half-life across 38 distinct signals was 28 weeks. The 25th–75th percentile band was 14–62 weeks. The longest-lived signal in our book has a fitted half-life of 4.1 years. The shortest is 6 weeks."
        },
        {
          "kind": "quote",
          "text": "An edge you cannot describe is a guess. An edge you cannot measure is a story."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "What this means"
        },
        {
          "kind": "paragraph",
          "text": "If a signal's PnL has not justified its capital allocation in two half-lives, it should be retired. Not because we are sure it will not recover — that is impossible to know — but because the alternative is a portfolio that grows monotonically and never disposes of dead weight."
        },
        {
          "kind": "code",
          "language": "python",
          "text": "from scipy.optimize import curve_fit\n\ndef decay(t, a, k):\n    return a * np.exp(-k * t)\n\nfor sig in live_signals:\n    t = sig.weeks_live\n    pnl = sig.cum_pnl_pct\n    (a, k), _ = curve_fit(decay, t, pnl, p0=[pnl[-1], 0.025])\n    half_life_weeks = np.log(2) / k\n    print(f\"{sig.name}: half-life = {half_life_weeks:.1f}w\")"
        }
      ]
    },
    {
      "id": "a02",
      "cat": "Market Note",
      "title": "Funding rates as a regime signal",
      "author": "N. Patel",
      "date": "2024-09-04",
      "read": 6,
      "tag": "Crypto",
      "lead": "Perpetual funding rates carry more regime information than spot returns when the basket is wide enough — here is the simple decomposition we use.",
      "body": [
        {
          "kind": "paragraph",
          "text": "Ask a crypto PM to describe the current regime and the answer usually begins with price: bitcoin is bid, bitcoin is heavy, the bounce stalled at a prior range high. Price is the last thing we look at. We start with funding, because funding is where leverage pays rent."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "Why funding beats spot"
        },
        {
          "kind": "paragraph",
          "text": "A perpetual's funding rate is the price the long book pays the short book (or vice versa) to keep the perp tethered to the index. When the aggregate book is long and levered, funding is positive. When positioning flips, funding inverts. A cross-sectional average across a wide basket — we use the top 30 by open interest — is a direct readout of leveraged conviction, sampled every eight hours, and mostly immune to the single-asset squeezes that make spot returns noisy."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "The decomposition"
        },
        {
          "kind": "paragraph",
          "text": "We separate the funding tape into three legs. The level (is the basket paying or being paid?), the dispersion (are a handful of names carrying the signal, or is it broad-based?), and the term — the gap between the perp funding rate and the one-month basis on the same underlying. The three components move independently enough that each is tradable on its own."
        },
        {
          "kind": "quote",
          "text": "Price tells you where the tape closed. Funding tells you who was willing to pay to be there."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "What we do with it"
        },
        {
          "kind": "paragraph",
          "text": "When level is high and dispersion is narrow, we fade — the basket is paying a crowded long, which historically reverts. When level is high and dispersion is wide, we ride — it is still a long-leaning tape, but the positioning is diffuse. The term-structure leg gates how much of the book we allocate: negative term (perp funding under basis) means leverage is thinning out and we cut gross by a third."
        },
        {
          "kind": "code",
          "language": "python",
          "text": "def regime(funding_df, basis_df, top_n=30):\n    # basket = top N names by open interest\n    basket = funding_df.rank(axis=1).le(top_n)\n    f = funding_df.where(basket)\n\n    level = f.mean(axis=1)\n    dispersion = f.std(axis=1)\n    term = (f.mean(axis=1) - basis_df.mean(axis=1))\n\n    return pd.DataFrame({\n        'level': level,\n        'dispersion': dispersion,\n        'term': term,\n    })"
        }
      ]
    },
    {
      "id": "a03",
      "cat": "Technical",
      "title": "A practical guide to walk-forward",
      "author": "PowerQuant Research",
      "date": "2024-10-22",
      "read": 12,
      "tag": "Methodology",
      "lead": "Walk-forward analysis is the discipline most retail backtests skip. We describe the parameters that actually matter and how to debug a model that passes in-sample but breaks out-of-sample.",
      "body": [
        {
          "kind": "paragraph",
          "text": "Walk-forward is not a backtest technique — it is a discipline for telling the truth. A model fit on all of history and evaluated on all of history will always look good. The only useful question is how the model would have behaved if you had actually deployed it, re-fit at a reasonable cadence, on data you had at the time."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "Three parameters, only three"
        },
        {
          "kind": "paragraph",
          "text": "Walk-forward has three knobs that matter: the in-sample window, the out-of-sample window, and the refit cadence. Every other choice is cosmetic. We default to 24 months in-sample, 3 months out-of-sample, and monthly refit. If the strategy is not robust to moving any of those by ±50%, it is not a strategy — it is a backtest."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "The failure mode nobody talks about"
        },
        {
          "kind": "paragraph",
          "text": "The most common walk-forward failure is not overfitting. It is parameter instability: the optimum shifts between adjacent windows. If the chosen lookback is 42 days in Q1 and 14 days in Q2, the strategy is not learning — it is chasing noise. We plot the chosen parameter as a time series and require that its coefficient of variation stay under 0.4. Anything above that is a warning sign the underlying signal has no persistent shape."
        },
        {
          "kind": "quote",
          "text": "A strategy that chooses a different answer every quarter is not a strategy. It is a hyperparameter search with a confident voice."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "Debugging an IS/OOS gap"
        },
        {
          "kind": "paragraph",
          "text": "When a model passes in-sample and fails out-of-sample, the instinct is to tighten the in-sample fit. That is the wrong direction. Loosen it. Add regularization, increase the minimum training window, or drop the weakest feature. The goal is not the best in-sample Sharpe — it is the smallest in-sample/out-of-sample gap. We track that gap per fold and require it to be under 30% of the in-sample Sharpe before a strategy graduates to paper trading."
        },
        {
          "kind": "code",
          "language": "python",
          "text": "def walk_forward(df, model, is_months=24, oos_months=3, step_months=1):\n    results = []\n    for fold_start in monthly_cursor(df, is_months, oos_months, step_months):\n        is_end = fold_start + relativedelta(months=is_months)\n        oos_end = is_end + relativedelta(months=oos_months)\n        train = df.loc[fold_start:is_end]\n        test = df.loc[is_end:oos_end]\n        m = model.fit(train)\n        results.append({\n            'fold': fold_start,\n            'params': m.params,\n            'is_sharpe': sharpe(m.predict(train)),\n            'oos_sharpe': sharpe(m.predict(test)),\n        })\n    return pd.DataFrame(results)"
        }
      ]
    },
    {
      "id": "a04",
      "cat": "Research",
      "title": "Volatility carry, decomposed",
      "author": "N. Patel",
      "date": "2024-11-08",
      "read": 11,
      "tag": "Volatility",
      "lead": "Most vol-carry strategies sell variance and call it a day. We separate the term-structure and skew components and show which one is actually paying.",
      "body": [
        {
          "kind": "paragraph",
          "text": "The headline vol-carry trade — short front-month variance, delta-hedged — has worked for decades because implied has structurally exceeded realized. That part is not a secret. The interesting question is which slice of the variance risk premium is paying in the current regime, and whether you can isolate it without taking the whole trade."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "Two premia, not one"
        },
        {
          "kind": "paragraph",
          "text": "We decompose the variance risk premium into a term-structure component — the gap between the front and the three-month — and a skew component — the gap between the 25-delta put and the 25-delta call implied vols. The first pays you for providing calendar insurance. The second pays you for providing tail insurance. They have different PnL profiles, different drawdown shapes, and, crucially, different correlations with the equity tape."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "Which one is paying right now"
        },
        {
          "kind": "paragraph",
          "text": "Since mid-2023 the term-structure leg has been shallow and the skew leg has been paying most of the check. Skew richness tends to persist — once the put book is bid, hedgers stay bid — and it has delivered about 70% of the total variance premium in the last six quarters. Shorting skew in isolation (via a delta-hedged risk reversal) has outperformed the headline variance short by 0.4 units of Sharpe over the same window."
        },
        {
          "kind": "quote",
          "text": "Selling variance is not one trade. It is three, and two of them are usually a rounding error."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "Sizing the decomposed book"
        },
        {
          "kind": "paragraph",
          "text": "We size the term and skew legs independently. Each has its own ex-ante vol target, its own drawdown cutoff, and its own regime filter — term shrinks to zero when the VIX futures curve goes into backwardation; skew shrinks when 25-delta skew falls below its trailing 20th percentile. The combined book runs leaner than a naive short-variance strategy and survives regime shifts that flatten the old trade."
        }
      ]
    },
    {
      "id": "a05",
      "cat": "Market Note",
      "title": "What the rates curve is telling us",
      "author": "D. Caldwell",
      "date": "2024-12-02",
      "read": 5,
      "tag": "Macro",
      "lead": "The 2s10s and 5s30s are sending different signals. Here is the simple framework we use to reconcile them when sizing the rates book.",
      "body": [
        {
          "kind": "paragraph",
          "text": "A flat yield curve is a consensus. A twisting yield curve is a conversation. Right now the front end and the long end are telling different stories, and the rates book has to decide which one it is trading."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "Two slopes, two narratives"
        },
        {
          "kind": "paragraph",
          "text": "The 2s10s is a cyclical signal. It steepens when the market expects cuts and flattens when it expects hikes. The 5s30s is a term-premium signal. It steepens when investors demand more compensation for holding duration, regardless of the cycle. When both move together, the story is simple. When they diverge — as they have for most of 2024 — the book needs a framework."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "The reconciliation"
        },
        {
          "kind": "paragraph",
          "text": "Our rule of thumb: price the 2s10s off the cycle and the 5s30s off issuance. When the front steepens but the back flattens, the market is pricing cuts without pricing term premium — a setup that historically resolves in favor of the front. When the back steepens but the front is flat, term premium is waking up and duration hedges outperform outright shorts."
        },
        {
          "kind": "quote",
          "text": "A yield curve is not one number. It is a conversation between the macro cycle and the Treasury calendar."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "Sizing in the current regime"
        },
        {
          "kind": "paragraph",
          "text": "We are running the rates book with a modest front-end steepener and a neutral long end. The book is sized to a half-unit of our normal vol target — enough to participate if the cycle leg pays, not so much that a surprise issuance shock takes out the year."
        }
      ]
    },
    {
      "id": "a06",
      "cat": "Technical",
      "title": "Engineering for deterministic backtests",
      "author": "PowerQuant Research",
      "date": "2025-01-14",
      "read": 14,
      "tag": "Engineering",
      "lead": "If your backtest is not bit-identical between two runs on the same input, you are debugging the wrong thing. Here is the engineering checklist we apply.",
      "body": [
        {
          "kind": "paragraph",
          "text": "The most expensive hours in a systematic shop are the ones spent chasing a number that changes between runs. A 0.1 Sharpe wobble that turns out to be pandas hash randomization has killed more Friday evenings than any drawdown. Determinism is not a nice-to-have — it is the foundation every other claim about a strategy rests on."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "The four usual suspects"
        },
        {
          "kind": "paragraph",
          "text": "In our experience, non-determinism in a Python/pandas backtest almost always traces to one of four sources: unordered dictionaries, unseeded randomness, floating-point non-associativity inside groupby operations, and time-of-day dependencies that silently creep in through `datetime.now()` or timezone conversions."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "The checklist"
        },
        {
          "kind": "paragraph",
          "text": "We pin `PYTHONHASHSEED`, seed every RNG at the top of the entry point, force stable sorts on any groupby that feeds a downstream calculation, and refuse to merge a strategy whose backtest changes between two invocations on the same data. A pre-merge hook runs the backtest twice and compares the equity curves byte-for-byte. If they differ, the merge is blocked."
        },
        {
          "kind": "quote",
          "text": "A non-deterministic backtest is not a backtest. It is a probability distribution over strategies that happen to share a name."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "What we do when it still drifts"
        },
        {
          "kind": "paragraph",
          "text": "Occasionally a downstream library update will introduce a subtle drift — a new groupby implementation, a different float-to-string rounding, a rewritten numeric kernel. When that happens we roll forward: a single PR bumps the library, re-runs all backtests, and stores the new reference curves alongside a diff. The old curves stay in the repository. The audit trail is the point."
        },
        {
          "kind": "code",
          "language": "python",
          "text": "import os, random, numpy as np\n\nSEED = 20240114\nos.environ['PYTHONHASHSEED'] = str(SEED)\nrandom.seed(SEED)\nnp.random.seed(SEED)\n\n# stable sorts everywhere a groupby feeds a cumulative\nreturns = df.groupby('symbol', sort=True).apply(compute_returns)"
        }
      ]
    },
    {
      "id": "a07",
      "cat": "Research",
      "title": "Capacity, decay, and the case for closing books",
      "author": "D. Caldwell",
      "date": "2025-02-10",
      "read": 8,
      "tag": "Research",
      "lead": "An edge that scales is rare. An edge that scales forever is fiction. We show how published capacity numbers correlate with realized live-stage decay.",
      "body": [
        {
          "kind": "paragraph",
          "text": "Every strategy has a capacity — the AUM above which slippage and market impact eat the edge. Most shops either refuse to publish theirs or publish a number that is politely described as optimistic. We publish ours and we close books when they are full."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "The data"
        },
        {
          "kind": "paragraph",
          "text": "We pulled the last six years of live-stage Sharpe for 38 strategies across our book and two partner funds. For each, we logged the ratio of realized AUM to pre-launch capacity estimate. The correlation is stark: strategies that crossed 80% of their stated capacity lost, on average, 0.6 units of Sharpe over the following twelve months. Strategies that stayed under 50% of capacity lost 0.1."
        },
        {
          "kind": "quote",
          "text": "Capacity is the only parameter of a strategy that gets worse the more you trust it."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "Why we close early"
        },
        {
          "kind": "paragraph",
          "text": "We close a book at 70% of capacity. Not at 100%. The last 30% costs more than it earns because the marginal dollar trades at the worst prices, and because the drawdown tail is heavier as you approach the capacity ceiling. Closing early is the single biggest operational decision that separates shops that survive ten years from shops that close in three."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "The subscriber implication"
        },
        {
          "kind": "paragraph",
          "text": "If you are subscribed to a PowerQuant strategy and it stops accepting new capital, that is not a marketing problem. It is the single most informative signal about the strategy you will receive. A closed book is a working book."
        }
      ]
    },
    {
      "id": "a08",
      "cat": "Market Note",
      "title": "Crypto basis after the ETFs",
      "author": "N. Patel",
      "date": "2025-03-04",
      "read": 6,
      "tag": "Crypto",
      "lead": "Spot ETFs changed the structure of crypto basis trades. We track where the trade still pays and where the carry has compressed below funding costs.",
      "body": [
        {
          "kind": "paragraph",
          "text": "Crypto basis — long spot, short future, collect the carry — was the textbook trade of 2021 and 2022. Spot ETFs changed the mechanics, and the trade does not look the way it used to. What it looks like now is worth understanding before committing capital."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "What the ETFs did"
        },
        {
          "kind": "paragraph",
          "text": "The ETFs pulled a large, rate-insensitive spot buyer into the book, and they pulled basis-sensitive leverage out. The practical effect is that the three-month basis on BTC has compressed by roughly 400 basis points relative to its pre-ETF mean, and the term structure is meaningfully flatter. On ETH the compression is smaller but directionally identical."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "Where the trade still pays"
        },
        {
          "kind": "paragraph",
          "text": "The trade still pays in two places. First, during the 48 hours around a large ETF creation event, when spot temporarily dislocates from the futures reference price — the legacy basis trade, compressed to a much shorter horizon. Second, on the mid-cap names that never got an ETF, where structural shorts still pay funding into a lighter book and a motivated long can harvest the carry with minimal competition."
        },
        {
          "kind": "quote",
          "text": "A trade that worked because of structural dislocation does not stop working because the dislocation moved. It stops working because you stopped moving with it."
        },
        {
          "kind": "heading",
          "level": 2,
          "text": "Sizing implications"
        },
        {
          "kind": "paragraph",
          "text": "Our basis book is a third of the size it was two years ago, it rotates faster, and it lives almost entirely outside the top-five names. The all-in Sharpe is lower, but so is the correlation to the equity book, which is ultimately why we still keep the trade on the page."
        }
      ]
    }
  ],
  "tiers": [
    {
      "id": "institutional",
      "name": "Institutional",
      "tagline": "For funds and family offices",
      "price": "Contact",
      "capital": "$500K+",
      "strategies": 12,
      "features": [
        "All Professional features",
        "12 strategies",
        "White-glove onboarding",
        "Custom mandates"
      ],
      "excluded": []
    },
    {
      "id": "pro",
      "name": "Professional",
      "tagline": "For serious systematic traders",
      "price": 499,
      "capital": "$50K – $500K",
      "strategies": 8,
      "featured": true,
      "features": [
        "All Starter features",
        "8 strategies",
        "Priority support",
        "Weekly research"
      ],
      "excluded": [
        "White-glove onboarding"
      ]
    },
    {
      "id": "starter",
      "name": "Starter",
      "tagline": "For ambitious individuals",
      "price": 99,
      "capital": "$5K – $50K",
      "strategies": 2,
      "features": [
        "2 strategies",
        "Email support",
        "Monthly tear-sheets"
      ],
      "excluded": [
        "Priority support",
        "White-glove onboarding"
      ]
    }
  ],
  "team": [
    {
      "id": "amartin",
      "name": "A. Martin",
      "role": "Head of Operations",
      "bio": "Onboarding, compliance, and the boring work that keeps the lights on. Background in fund administration at a top-3 prime broker.",
      "init": "AM"
    },
    {
      "id": "dcaldwell",
      "name": "D. Caldwell",
      "role": "Co-founder, CIO",
      "bio": "Two decades running discretionary and systematic books across four asset classes. Previously head of quant at a multi-strategy fund.",
      "init": "DC"
    },
    {
      "id": "jvazquez",
      "name": "J. Vazquez",
      "role": "Head of Engineering",
      "bio": "Builds the trading and research stack. Previously infrastructure lead at a high-frequency market maker.",
      "init": "JV"
    },
    {
      "id": "npatel",
      "name": "N. Patel",
      "role": "Head of Research",
      "bio": "Statistical learning, signal decay, and regime detection. PhD in applied mathematics; six years on the buy-side before joining PowerQuant.",
      "init": "NP"
    },
    {
      "id": "skim",
      "name": "S. Kim",
      "role": "Head of Risk",
      "bio": "Variance budgets, stress tests, and the discipline to turn off models that stop working. Two decades on the risk side of long/short equity.",
      "init": "SK"
    }
  ],
  "pages": {
    "about": {
      "slug": "about",
      "seo": {
        "title": "About — PowerQuant",
        "description": "PowerQuant is a systematic trading firm founded in 2018 with desks in Ghana, Hong Kong, and Singapore."
      },
      "sections": [
        {
          "kind": "section-intro",
          "eyebrow": "ABOUT",
          "heading": "A small team that ships.",
          "body": "PowerQuant is a systematic trading firm — equal parts research, engineering, and risk. We believe in transparency, typed contracts, and never showing a backtest as live."
        },
        {
          "kind": "three-column",
          "columns": [
            {
              "num": "GH",
              "heading": "Accra",
              "body": "Research desk and strategy incubation. Where new signals are prototyped, validated, and broken on purpose before they see a dollar of live capital."
            },
            {
              "num": "HK",
              "heading": "Hong Kong",
              "body": "APAC execution and venue operations. Handles connectivity, matching engine integrations, and the overnight risk book while the rest of the firm is asleep."
            },
            {
              "num": "SG",
              "heading": "Singapore",
              "body": "Treasury, compliance, and client coverage for Asia-Pacific mandates. Our regulated entity of record for non-US subscribers."
            }
          ]
        },
        {
          "kind": "pull-quote",
          "quote": "We would rather publish a drawdown than hide behind a backtest.",
          "cite": "D. Caldwell, CIO"
        },
        {
          "kind": "cta-strip",
          "heading": "Get in touch — info@powerquanthq.com",
          "ctas": [
            {
              "label": "Email the desk",
              "href": "mailto:info@powerquanthq.com",
              "variant": "primary"
            },
            {
              "label": "See pricing",
              "href": "/pricing",
              "variant": "default"
            }
          ]
        }
      ]
    },
    "docs": {
      "slug": "docs",
      "seo": {
        "title": "Docs — PowerQuant",
        "description": "How PowerQuant's content layer works."
      },
      "sections": [
        {
          "kind": "section-intro",
          "eyebrow": "DOCS",
          "heading": "JSON in, app out.",
          "body": "Every visible string on this site is a field in a JSON file under `content/`. Validation is enforced by Zod schemas and runs in CI."
        },
        {
          "kind": "code-sample",
          "language": "ts",
          "heading": "The contract",
          "body": "Adding a new strategy is editing one JSON file. The schema tells you which fields are required and what shape they take.",
          "code": "import { z } from 'zod';\n\nexport const StrategySchema = z.object({\n  id: z.string().regex(/^[a-z][a-z0-9-]*$/),\n  code: z.string().regex(/^PQ-[A-Z]{3}-\\d{3}$/),\n  // ... see src/content/schemas/strategy.ts\n});"
        }
      ]
    },
    "home": {
      "slug": "home",
      "seo": {
        "title": "PowerQuant — Systematic Trading",
        "description": "PowerQuant builds systematic trading strategies you can audit, subscribe to, and hold accountable."
      },
      "sections": [
        {
          "kind": "hero",
          "eyebrow": "EST 2018 · GHANA · HONG KONG · SINGAPORE",
          "headline": "Systematic, transparent, <em>accountable</em>.",
          "sub": "Twelve strategies. One typed contract. Every metric is testable, every trade is logged, every drawdown is owned.",
          "ctas": [
            {
              "label": "See strategies",
              "href": "/strategies",
              "variant": "primary"
            },
            {
              "label": "View performance",
              "href": "/performance",
              "variant": "ghost"
            }
          ],
          "meta": [
            {
              "key": "LIFETIME RETURN",
              "value": "+142.8%",
              "detail": "Mar 2018 – now"
            },
            {
              "key": "SHARPE",
              "value": "2.10",
              "detail": "book-weighted"
            },
            {
              "key": "AUM",
              "value": "$420M",
              "detail": "across mandates"
            },
            {
              "key": "STRATEGIES",
              "value": "12",
              "detail": "live"
            }
          ]
        },
        {
          "kind": "section-intro",
          "eyebrow": "THESIS",
          "heading": "We build models. We trade them. We tell you when they break.",
          "body": "Most systematic shops show you a backtest and ask for capital. We show you the live equity curve, the drawdown windows, the trades, and the moments we turned a model off."
        },
        {
          "kind": "three-column",
          "columns": [
            {
              "num": "01",
              "heading": "Typed end-to-end",
              "body": "Every strategy is described by a Zod schema. The website cannot ship if the data does not parse."
            },
            {
              "num": "02",
              "heading": "Auditable history",
              "body": "Trade logs and equity curves are versioned in git. You can watch a strategy degrade in real time."
            },
            {
              "num": "03",
              "heading": "Capacity-aware",
              "body": "Every strategy publishes its capacity. We close subscriptions before the curve breaks."
            }
          ]
        },
        {
          "kind": "pull-quote",
          "quote": "An edge you cannot describe is a guess. An edge you cannot measure is a story.",
          "cite": "D. Caldwell, CIO"
        },
        {
          "kind": "cta-strip",
          "heading": "Subscribe to the book.",
          "ctas": [
            {
              "label": "View pricing",
              "href": "/pricing",
              "variant": "primary"
            },
            {
              "label": "Talk to us",
              "href": "/about",
              "variant": "default"
            }
          ]
        }
      ]
    },
    "performance": {
      "slug": "performance",
      "seo": {
        "title": "Performance — PowerQuant",
        "description": "Capital-weighted composite curve and per-strategy table for the live PowerQuant book."
      },
      "sections": [
        {
          "kind": "section-intro",
          "eyebrow": "PERFORMANCE",
          "heading": "The whole book, in one table.",
          "body": "Sortable by Sharpe, CAGR, max drawdown, win rate, or lifetime return. The composite curve above is capital-weighted by min-capital — what an even allocation to the live book would have produced."
        }
      ]
    },
    "pricing": {
      "slug": "pricing",
      "seo": {
        "title": "Pricing — PowerQuant",
        "description": "Three tiers, no lock-in, transparent fees."
      },
      "sections": [
        {
          "kind": "section-intro",
          "eyebrow": "PRICING",
          "heading": "Capital under your terms.",
          "body": "Pick the tier that matches your capital and the breadth of strategies you want. No lock-in, no surprise fees."
        }
      ]
    },
    "research": {
      "slug": "research",
      "seo": {
        "title": "Research — PowerQuant",
        "description": "Notes from the desk: research, market notes, and technical pieces."
      },
      "sections": [
        {
          "kind": "section-intro",
          "eyebrow": "RESEARCH",
          "heading": "Notes from the desk.",
          "body": "Three streams: long-form Research, in-the-moment Market Notes, and Technical pieces on engineering and methodology."
        }
      ]
    }
  }
} as const;
export default index;
